import { VisitCreatingMiniFormProps } from '@lmt/unicorn-shared/app/components/calendar/visit/common/types';
import { TagsEditor } from '@lmt/unicorn-shared/app/components/common/ui-kit/tags/TagsEditor';
import { CaseData } from '@lmt/unicorn-shared/app/helpers/case-queries';
import React, { FC, useRef } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Field } from '../../../common/Field';
import {
  PatientSearch,
  SearchInputPatientData,
} from '../../../common/patient/PatientSearch';
import { DateTimeIntervalPicker } from '../../../common/ui-kit/inputs/date-time/DateTimeIntervalPicker';
import { DropDownInput } from '../../../common/ui-kit/inputs/dropdown/DropDownInput';
import styles from './VisitCreatingMiniForm.module.scss';

export const dropdownCalloutHeight = 200;

export const VisitCreatingMiniForm: FC<VisitCreatingMiniFormProps> = (
  props,
) => {
  const {
    visitTypes,
    form,
    cases,
    addNewPatient,
    addNewCase,
    onChangeCase,
    selectPatient,
    eventTypeSelection,
  } = props;

  const i18n = useTranslation();
  const selectPatientInInput =
    useRef<(patient: SearchInputPatientData) => void>();

  const { formState, watch, control, setValue } = form;

  const patient = watch('patient');
  const note = watch('note');

  return (
    <div className={styles.bodyOverflowContainer} data-test-id="visitMiniForm">
      {eventTypeSelection}
      <Field
        title={i18n.t('event.visit.fields.patient')}
        required={true}
        linkProps={{
          title: i18n.t('event.visit.add_new_patient'),
          onClick: () => addNewPatient(selectPatientInInput.current),
        }}
      >
        <Controller
          control={control}
          name={'patient'}
          render={({ field: { value } }) => (
            <PatientSearch
              optionContainerClassName={styles.patientSearchOption}
              isOnlyActive={true}
              onSelectedPatientChanged={selectPatient}
              selectedPatient={value}
              patientsLimit={9}
              errorText={(formState.errors.patient as any)?.message}
              autoFocus={true}
              variant={'formInput'}
            />
          )}
        />
      </Field>
      <Field
        title={i18n.t('event.visit.fields.case')}
        required={true}
        className={styles.field}
        linkProps={{
          title: i18n.t('event.visit.add_new_case'),
          disabled: !patient,
          onClick: () => addNewCase(patient?.id),
        }}
      >
        <Controller
          control={control}
          name={'caseId'}
          render={({ field: { onChange, value } }) => (
            <DropDownInput<CaseData, true, true>
              useIdFunctionAsValue={true}
              required={true}
              variant={'formInput'}
              options={cases}
              disabled={!patient}
              value={value}
              onValueChanged={(selectedCase) => onChangeCase(selectedCase.id)}
              idFunction={'id'}
              getOptionLabel={'title'}
              errorText={formState.errors.caseId?.message}
              testId="titleDropDown"
              getOptionDisabled={(x) => x.isClosed}
            />
          )}
        />
      </Field>
      <Field
        title={i18n.t('event.visit.fields.visit_type')}
        required={true}
        className={styles.field}
      >
        <Controller
          control={control}
          name={'visitTypeId'}
          render={({ field: { onChange, value } }) => (
            <DropDownInput
              useIdFunctionAsValue={true}
              required={true}
              variant={'formInput'}
              options={visitTypes}
              value={value}
              onValueChanged={(selectedType) => onChange(selectedType.id)}
              idFunction={'id'}
              getOptionLabel={'label'}
              errorText={formState.errors.visitTypeId?.message}
              testId="visitTypeDropDown"
            />
          )}
        />
      </Field>
      <Controller
        control={control}
        name={'dateTimeInterval'}
        render={({ field: { onChange, value } }) => (
          <DateTimeIntervalPicker
            mode={'two-lines'}
            value={value}
            onIntervalChanged={onChange}
            className={styles.field}
            datePickerClassName={styles.datePicker}
            startDateError={!!formState.errors.dateTimeInterval?.startDate}
            startDateErrorText={
              (formState.errors.dateTimeInterval?.startDate as any)?.message
            }
            startTimeError={
              !!formState.errors.dateTimeInterval?.startTimeInMills
            }
            startTimeErrorText={
              formState.errors.dateTimeInterval?.startTimeInMills?.message
            }
            endDateError={!!formState.errors.dateTimeInterval?.endDate}
            endDateErrorText={
              (formState.errors.dateTimeInterval?.endDate as any)?.message
            }
            endTimeError={!!formState.errors.dateTimeInterval?.endTimeInMills}
            endTimeErrorText={
              formState.errors.dateTimeInterval?.endTimeInMills?.message
            }
          />
        )}
      />
      {/*<Controller*/}
      {/*  control={control}*/}
      {/*  name={'alertPatient'}*/}
      {/*  render={({ field: { onChange, value, name } }) => (*/}
      {/*    <CheckBox*/}
      {/*      title={i18n.t('event.visit.alert_1_day_before')}*/}
      {/*      className={styles.field}*/}
      {/*      checked={!!value}*/}
      {/*      name={name}*/}
      {/*      onChange={() => {*/}
      {/*        if (value) {*/}
      {/*          onChange(null);*/}
      {/*        } else {*/}
      {/*          onChange(alertPatientOptions[0].intervalBeforeInMills);*/}
      {/*        }*/}
      {/*      }}*/}
      {/*      testId="alertOneDayBefore"*/}
      {/*    />*/}
      {/*  )}*/}
      {/*/>*/}
      {/*<CheckBox*/}
      {/*  {...register('waitingList')}*/}
      {/*  title={i18n.t('event.visit.waiting_list')}*/}
      {/*  className={styles.field}*/}
      {/*  testId={'waitingListCheckbox'}*/}
      {/*/>*/}

      <Field title={i18n.t('event.visit.fields.note')} className={styles.field}>
        <TagsEditor
          value={note ?? ''}
          onChange={(e, value) =>
            setValue('note', value, { shouldDirty: true })
          }
          isMultiline={true}
        />
      </Field>
    </div>
  );
};
